import type {GridInitialState} from "@mui/x-data-grid-premium";

/** MUI's `breakpoints.down('sm')`; the theme keeps the default breakpoints. */
const PHONE_QUERY = '(max-width: 599.95px)';

/**
 * Starting layout for a Supplier 360 grid on narrow screens: the identifying column stays pinned on
 * the left while the rest scrolls, and on phones the minor columns start hidden (the columns button
 * brings them back). Read once when the grid mounts; a layout the user saved still wins.
 */
export function supplierGridInitialState(nameField: string, minorFields: string[] = []): GridInitialState {
    const isPhone = typeof window !== 'undefined' && window.matchMedia(PHONE_QUERY).matches;
    return {
        pinnedColumns: {left: [nameField]},
        ...(isPhone && minorFields.length > 0
            ? {columns: {columnVisibilityModel: Object.fromEntries(minorFields.map(field => [field, false]))}}
            : {}),
    };
}
